import {useEffect, useState} from 'react';
import {confirmAlert} from "react-confirm-alert";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";

import Field from "../../Field";
import Alert from "../../../alert/Alert";
import Button from "../../../form/Button";
import Loading from "../../../generic/Loading";
import UseFieldConfig from "../../../querybuilder/UseFieldConfig";

import {AlertTriangle} from "react-feather";
import {InfoLabel, SettingsLabel} from "../../../../config/Config";

import ModalContent from "../../components/Lookup/Modal";
import './Lookup.scss'
import Select from "../../../../components/input/select";
import UseSetterNodeValue from "../../hooks/UseSetterNodeValue";
import UseGetterNodeValue from "../../hooks/UseGetterNodeValue";


const Lookup = (props) => {
    const {journey, currentNode} = props
    const [configFields, setConfigFields] = useState({})
    const [optionFields, setOptionFields] = useState([])
    const [loading, setLoading] = useState(true)


    const getError = (propertyName, currentNode) => {
        return currentNode?.data?.form?.tabs?.settings?.fields?.[propertyName]?.error || null;
    };


    const handleSave = (data) => {
        UseSetterNodeValue(currentNode, 'settings', 'config', data.config)
        UseSetterNodeValue(currentNode, 'settings', 'query', data.query)

        UseSetterNodeValue(currentNode, 'settings', 'use_limit', data.use_limit)
        UseSetterNodeValue(currentNode, 'settings', 'use_ws_limit', data.use_ws_limit)
        UseSetterNodeValue(currentNode, 'settings', 'limit', data.limit)
        UseSetterNodeValue(currentNode, 'settings', 'method', data.method)
        UseSetterNodeValue(currentNode, 'settings', 'endpoint', data.endpoint)
        UseSetterNodeValue(currentNode, 'settings', 'headers', data.headers)
        UseSetterNodeValue(currentNode, 'settings', 'body', data.body)
    }


    const GetFields = async () => {
        const options = []
        const configFields = {audience: {}, history: {}}

        journey.Audience?.fields && journey.Audience.fields.map((field) => {


            if (field?.field_target === 'audience') {
                if (field.is_filter === "on") {
                    configFields.audience[field.name] = UseFieldConfig(field)
                }
                options.push({value: field._id.$oid, label: field.name})
            }

            if (field?.field_target === 'history') {
                if (field?.can_be_deleted !== false && field.is_filter === "on") {
                    configFields.history[field.name] = UseFieldConfig(field)
                }
            }


        })


        return {
            configFields: configFields,
            optionFields: options
        }
    }


    useEffect(() => {
        GetFields().then((response) => {
            setConfigFields(response.configFields)
            setOptionFields(response.optionFields)
            setLoading(false)
        })
    }, [])


    const showRules = (event) => {
        event.preventDefault()
        confirmAlert({
            customUI: ({onClose}) => {
                return <ModalContent onClose={onClose} currentNode={currentNode} fields={configFields} onSave={handleSave}/>
            }
        });
    }


    return (
        <div>
            {loading && <Loading/>}
            {!loading && <div className="Form">
                <form className="FormComponent">
                    <div className="max-width-500">

                        <Alert
                            className="alert-primary"
                            message="Through this component you can checks user interactions inside campaign. "
                            docs={{message: 'For more info  ', path: '/docs/journeys/lookup/'}}
                        />


                        <div className="FieldsetTabs">
                            <Tabs defaultActiveKey="0">
                                <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                    <Select
                                        isReady={!loading}
                                        tab="settings"
                                        name="fields"
                                        type="select"
                                        label="Choose fields"
                                        wrapper="form-group"
                                        className="input-sm"
                                        classNamePrefix="input-sm"
                                        placeholder="Choose fields"
                                        hideSelectedOptions={false}
                                        error={getError('fields', currentNode)}
                                        required={false}
                                        isMulti={true}
                                        isSearchable={true}
                                        options={optionFields}
                                        defaultValue={UseGetterNodeValue(currentNode, 'settings', 'fields', [])}
                                        onChange={ev => UseSetterNodeValue(currentNode, 'settings', 'fields', ev)}
                                    />
                                    <div>
                                        <Button
                                            type="button"
                                            label="Set Rules"
                                            onClick={showRules}
                                            className="btn btn-sm btn-primary"
                                        />
                                        {getError('config', currentNode) && <span className="ms-2 error">
                                            <AlertTriangle/> {getError('config', currentNode)}
                                        </span>}
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                    <div>

                                        <Field
                                            tab="info"
                                            name="id"
                                            type="text"
                                            canCopy={true}
                                            disabled={true}
                                            node={currentNode}
                                            wrapper="form-group"
                                            label="Component Id"
                                            defaultValue={currentNode.id}
                                        />
                                        <Field
                                            tab="info"
                                            name="title"
                                            type="text"
                                            label="Title"
                                            node={currentNode}
                                            wrapper="form-group"
                                            placeholder="Type an descriptive title"
                                        />
                                        <Field
                                            tab="info"
                                            type="textarea"
                                            name="description"
                                            node={currentNode}
                                            label="Description"
                                            wrapper="form-group"
                                            className="form-control"
                                            placeholder="Type a short description"
                                        />
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </form>
            </div>}
        </div>
    )
}

export default Lookup;